import React from 'react';
import ReactDiffViewer, { DiffMethod } from 'react-diff-viewer';
import Error from './Error.jsx';

class Diff extends React.Component{
    constructor(props){
        super(props);

        this.gate = props.gate;
        this.cache = {};

        this.state = {
            history: [],
            lhs: 'buffer',
            rhs: 'buffer',
            lhsBody: props.body,
            rhsBody: props.body,
            loading: true,
            rhsLoading: false,
            lhsLoading: false,
        }

        this.load = this.load.bind(this);
        this.loadLHS = this.loadLHS.bind(this);
        this.loadRHS = this.loadRHS.bind(this);

    }

    componentDidMount(){
        var self = this;
        this.gate.getCardHistory(
            this.props.corpus, 
            this.props.code,
            (history) => {
                if(history.length == 0){
                    self.props.raiseError(
                        <Error 
                            text={'История карточки пуста.'}
                            onDismiss={()=>{
                                self.props.dismissError();
                                self.props.close();
                            }}
                        />
                    );
                    return;
                }

                var rHistory = [
                    {
                        versionId: 'buffer',
                        message: 'Текущая несохраненная версия'
                    }
                ];
                for(var i = 0; i < history.length; i++){
                    rHistory.push(history[i]);
                }
                self.load(rHistory[1].versionId, 'lhs');
                self.setState({
                    history: rHistory, 
                    lhs: rHistory[1].versionId,
                    loading: false
                })
            },
            (error)=>{
                self.props.raiseError(
                    <Error 
                        text={'Не удалось загрузить историю карточки из Github. Ошибка '+error}
                        onDismiss={()=>{
                            self.props.dismissError();
                            self.props.close();
                        }}
                    />
                );
            }
        );
    }

    load(versionId, side){
        var sideBody = side+'Body';
        if(versionId == 'buffer'){
            this.state[sideBody] = this.props.body;
            this.state[side] = versionId;
            this.setState(this.state);
            return;
        }
        if(this.cache[versionId]){
            this.state[sideBody] = this.cache[versionId];
            this.state[side] = versionId;
            this.setState(this.state);
            return;
        }
        
        var st = {};
        st[side+"Loading"] = true;
        this.setState(st)
        
        this.gate.getCardVersion(
            this.props.corpus, 
            this.props.code, 
            versionId,
            (body)=>{
                this.cache[versionId] = body;
                this.state[sideBody] = body;
                this.state[side] = versionId;
                this.state[side+"Loading"] = false;
                this.setState(this.state);
            },
            (error)=>{
                this.props.raiseError(
                    <Error 
                        text={'Не удалось получить версию карточки из Github. Ошибка '+error}
                        onDismiss={this.props.dismissError}
                    />
                );
            }
        );
    }

    loadLHS(e){
        var versionId = e.currentTarget.value;
        this.load(versionId, 'lhs');
    }

    loadRHS(e){
        var versionId = e.currentTarget.value;
        this.load(versionId, 'rhs');
    }

    render() {
        return(
            <div className="overlay">
                <div className="diff-panel">
                    <div className="window d-flex flex-column">
                        {this.state.loading ? (
                            <div className="loading"><h1><i className="fas fa-circle-notch fa-spin"></i></h1></div>
                        ) : (
                            <React.Fragment>
                                <table className="selector">
                                    <tbody>
                                        <tr>
                                            <td>
                                                <select className="custom-select" onChange={this.loadLHS} value={this.state.lhs}>
                                                    {this.state.history.map(version => (
                                                        <option value={version.versionId}　key={version.versionId}>
                                                            {version.message}
                                                        </option>
                                                    ))}
                                                </select>
                                            </td>
                                            <td className="sep"><div></div></td>
                                            <td>
                                                <select className="custom-select" onChange={this.loadRHS} value={this.state.rhs}>
                                                    {this.state.history.map(version => (
                                                        <option value={version.versionId} key={version.versionId}>
                                                            {version.message}
                                                        </option>
                                                    ))}
                                                </select>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>

                                <div className="flex-grow-1 d-flex  flex-column mt-2 diff-table-wrap">
                                    <div className="flex-grow-1 diff-table">
                                        <ReactDiffViewer
                                            oldValue={this.state.lhsBody}
                                            newValue={this.state.rhsBody}                           
                                            showDiffOnly={false}
                                            splitView={true}
                                            useDarkTheme={false}
                                            compareMethod={DiffMethod.WORDS}
                                            disableWordDiff={false}
                                        />
                                    </div>

                                    {this.state.lhsLoading && (
                                        <div className="left d-flex">
                                            <div className="loading">
                                                <h2><i className="fas fa-circle-notch fa-spin"></i></h2>
                                            </div>
                                        </div>
                                    )}
                                    
                                    {this.state.rhsLoading && (
                                        <div className="right d-flex">
                                            <div className="loading">
                                                <h2><i className="fas fa-circle-notch fa-spin"></i></h2>
                                            </div>
                                        </div>
                                    )}
                                </div>

                                <div className="close-btn" onClick={this.props.close}>
                                    <span className="fa fa-times"></span>
                                </div>
                            </React.Fragment>
                        )}
                        
                    </div>
                </div>
            </div>
        )
    }
}

export default Diff;